import { Categories } from '../constants';
import { RiskManagementRisksNamesBase } from './RiskManagementRisksNamesBase';

export class HumanBasedRisksNames extends RiskManagementRisksNamesBase {
  static getExtraFilters(): Array<any> {
    return [{ category: Categories.HUMAN_BASED_RISK }];
  }
}
